import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, FormCheck, Row, Col, Button, Alert  } from "react-bootstrap";
import api from "../../services/api";

export default function Cancela({ history, location }) {
    const [pessoa, setPessoa] = useState([]);
    const [receberEmail, setReceberEmail]= useState(false);
    const { email } = useParams();

    useEffect(() => {
        async function loadPessoa() {
          if (email.indexOf("@") > 1) {
            const response = await api.get(`/api/pessoa/${email}/publico`);
            setPessoa(response.data[0]);
          }
        }
        loadPessoa();
      }, [email]);

    async function handleSalvar(){
        var receberEmailAux = "N";
        if (receberEmail){
            receberEmailAux = "S";
        }
        const data = { 
            'idPessoa': pessoa.ID_PESSOA,
            'receberEmail': receberEmailAux
        };
        await api.put(
            `/api/pessoa/ReceberEmail`,
            data);
        window.location.href="/";
    }

    function handleSair(){
        window.location.href="/";
    }
    
    return (
        <>
          <Container>
            <Row>
              <Col sm={12}>
                <div className="voltar">
                  <a href="/">voltar</a>
                </div>
              </Col>
            </Row>
            <div className="quadro">
              <Row>
                <Col sm={12}>
                  <h2>
                    Cancelamento de envio de informações sobre Participações Sociais da ANA
                  </h2>
                </Col>
              </Row>
            </div>
            <div className="quadro">
              <Row>
                <Col sm={12}>
                  <br /><br />
                  <FormCheck>
                    <FormCheck.Input type={'checkbox'} 
                      className="receberEmail"
                      defaultChecked={receberEmail} 
                      onChange={event =>setReceberEmail(!receberEmail)}/>
                    <FormCheck.Label>Receber informações sobre Participações Sociais da ANA?</FormCheck.Label>
                  </FormCheck>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <br /><br />
                  <Alert variant={"primary"}>
                      {pessoa.NO_PESSOA}, para gerenciar o envio de informações de Participações Socias na ANA, basta  licar em seu Perfil (no cabeçalho, a direita e em cima). 
                  </Alert>
                </Col>
              </Row>
            </div>
            <Row>
                <Col sm={12}>
                    <Button variant="success" onClick={handleSalvar}>Confirmar alteração</Button>
                    <Button variant="secondary" onClick={handleSair}>Cancelar</Button>
                </Col>
            </Row>
      </Container>
    </>
  );
}